import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './analiticaActions';

class AnaliticaForm extends Component {

	state = {

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='id_grupo'
								component={Select}
								options={this.props.listaGrupo}
								label='Grupo *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>

			</ContentCard>
		);
    }


}

AnaliticaForm = reduxForm({form: 'analiticaForm', destroyOnUnmount: false})(AnaliticaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('analiticaForm')(state),
	registro: state.analitica.registro,
	listaGrupo: state.grupo.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AnaliticaForm);
